export const supportedSat = (satellites, selectedSatIndex) => {
    if (!satellites || satellites.length === 0 || selectedSatIndex === undefined) return false;
    const sat = satellites[selectedSatIndex];
    if (!sat?.satConfig) return false;
    return true;
};

export const parseDate = (date) => {
    const corrected = (typeof date !== "string" || date.endsWith("Z")) ? date : (date+"Z");
    return new Date(corrected);
};

export const isBB2 = (sat) => {
    return sat?.satConfig?.block === 2;
};

export const getSatName = (satId) => {
    if (satId === "BW3") return "BLUEWALKER-3";
    if (satId.startsWith("SM")) return "SPACEMOBILE-" + satId.slice(2);
    return null;
};
